/**
 * Singular Checkbox againt non-singular choices
 *
 * # Adding the singular-checkbox:
 * Checkbox that needs to be selectable alone (as it none of the rest)
 * Add "data-checkbox-singular"="1" attribute to input, any other singular checkboxed will be disabled on check
 *
 * The opposite action is
 *
 * # Adding the non-singular-checkbox aginst a singular-checkbox:
 * Add "data-checkbox-singular"="0" attribute to input, and  singular-checkbox=1 will be disabled on check
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
  "use strict";

  // Register click for the 1 Singular box
  $('input:checkbox[data-checkbox-singular=1]').click(function(){
      var $inputs = $('input:checkbox[data-checkbox-singular]');
      // check if clicked box is currently checked
      if($(this).is(':checked')){
          // disable all but checked checkbox
         $inputs.not(this).prop('disabled',true);
      }else{
          // if checkbox was unchecked
          // enable all checkboxes
         $inputs.prop('disabled',false);
      }
  });

  // Register click for the opposite
  $('input:checkbox[data-checkbox-singular=0]').click(function(){
      var $inputs = $('input:checkbox[data-checkbox-singular=1]');
      // check if any box is currently checked
      if($('input:checkbox[data-checkbox-singular=0]:checked').length){
          // disable all but checked checkbox
         $inputs.prop('disabled',true);
      }else{
          // if checkbox was unchecked
          // enable all checkboxes
         $inputs.prop('disabled',false);
      }
  });
});
